/* eslint-disable react/no-array-index-key */
import { Icon } from '@bwoty-web/ui-kit';
import {
  ICON_MISC_POOL_BEACH,
  ICON_TIME_LOCATION_ELEVATOR,
  ICON_TIME_LOCATION_HOTEL,
  ICON_TIME_LOCATION_HOTEL_ROOM,
  ICON_TRAVEL_PARKING,
  ICON_FOOD_BEVERAGE_RESTAURANT,
  ICON_TIME_LOCATION_HOTEL_SERVICE,
} from '@bwoty-web/ui-kit/icons';
import cx from 'classnames';
import PropTypes from 'prop-types';
import SectionParagraph from '../../../../common/sectionParagraph';

import './accessibilityContent.scss';

const AccessibilityContent = ({ content }) => {
  if (!content?.length) return null;

  const icons = {
    hcpElevator: ICON_TIME_LOCATION_ELEVATOR,
    hcpParking: ICON_TRAVEL_PARKING,
    hcpPool: ICON_MISC_POOL_BEACH,
    hcpRoom: ICON_TIME_LOCATION_HOTEL_ROOM,
    hcpWheelchair: ICON_TIME_LOCATION_HOTEL,
    hcpRestaurant: ICON_FOOD_BEVERAGE_RESTAURANT,
    hcpService: ICON_TIME_LOCATION_HOTEL_SERVICE,
  };

  return content.map((block, i) => (
    <div
      className={cx('gw-accessibility-block')}
      key={`accessibility-block-${i}`}
    >
      {block?.heading && (
        <div className={cx('gw-accessibility-block-heading__icon')}>
          {block?.blockId && <Icon path={icons[block.blockId]} />}
          <h3 className="gw-accessibility-block-heading">{block.heading}</h3>
        </div>
      )}
      <div className="gw-accessibility-block-content">
        {block.type === 'table2col' ? (
          <dl className="gw-accessibility-content__table">
            {block.paragraphs?.map((paragraph, pi) => {
              return (
                <div
                  className="gw-accessibility-content__table-row"
                  key={`accessibility-table-row-${pi}`}
                >
                  <dt>{paragraph.heading}</dt>
                  <dd>{paragraph.content}</dd>
                </div>
              );
            })}
          </dl>
        ) : (
          block.paragraphs?.map((paragraph, pi) => {
            return (
              <SectionParagraph
                className={cx({
                  'gw-section-content__paragraph-list': paragraph?.listItems,
                })}
                paragraph={paragraph}
                key={`section-paragraph-${pi}`}
              />
            );
          })
        )}
      </div>
    </div>
  ));
};

AccessibilityContent.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      blockId: PropTypes.string,
      type: PropTypes.string,
      paragraphs: PropTypes.arrayOf(
        PropTypes.shape({
          heading: PropTypes.string,
          content: PropTypes.string,
          listItems: PropTypes.arrayOf(PropTypes.string),
        }),
      ),
    }),
  ).isRequired,
};

export default AccessibilityContent;
